'use client';

import '@ui5/webcomponents/dist/Popover.js';
import { PopoverHorizontalAlign, PopoverPlacementType, PopoverVerticalAlign, PopupAccessibleRole } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Popover` component displays additional information for an object in a compact way and without leaving the page. The Popover can contain various UI elements, such as fields, tables, images, and charts. It can also include actions in the footer.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Popover)
 */
const Popover = withWebComponent('ui5-popover', ['headerText', 'horizontalAlign', 'opener', 'placementType', 'verticalAlign', 'accessibleName', 'accessibleNameRef', 'accessibleRole', 'initialFocus'], ['allowTargetOverlap', 'hideArrow', 'hideBackdrop', 'modal', 'open', 'preventFocusRestore'], ['footer', 'header'], ['after-close', 'after-open', 'before-close', 'before-open']);
Popover.displayName = 'Popover';
Popover.defaultProps = {
  horizontalAlign: PopoverHorizontalAlign.Center,
  placementType: PopoverPlacementType.Right,
  verticalAlign: PopoverVerticalAlign.Center,
  accessibleRole: PopupAccessibleRole.Dialog
};
export { Popover };